export enum CodeTypes {
  amplifyEnrollment = 'amplify-enrollment',
  singleSession = 'single-session',
}
